import { RavioliCommonContent } from "../../../../modules/content/components/RavioliCommonContent/RavioliCommonContent";
import { RavioliRichText } from "../../../../modules/content/components/RavioliRichText/RavioliRichText";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);

  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-6">
        {hasIntro ? (
          <RavioliCommonContent
            alignment={alignment}
            buttons={buttons}
            className="w-full border border-primary bg-collection p-6 lg:p-8"
            description={description}
            eyebrow={eyebrow}
            heading={heading}
          />
        ) : null}
        <RavioliRichText
          className="w-full [&_h2]:mt-12 [&_h2]:font-ravioli-display [&_h2]:text-3xl [&_h2]:font-bold [&_h2]:leading-tight [&_h2:first-child]:mt-0"
          content={content}
        />
      </div>
    </RavioliSection>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
